/*
 * @description:
 * @author: Jason Wong
 * @since: 2021-12-14 14:10:26
 */
import RibbonBlock from "./panelBlock.vue";
import RibbonPanel from "./panel.vue";
import RibbonTable from "./ribbonTable.vue";

import RibbonButton from "./blockComponents/ribbonButton.vue";
import RibbonCheck from "./blockComponents/ribbonCheck.vue";
import RibbonBlockGroup from "./blockComponents/blockGroup.vue";
import RibbonDropMenu from "./blockComponents/ribbonDropMenu.vue";
import RibbonDropMenuItem from "./blockComponents/ribbonDropMenuItem.vue";
import { firstLetterUpperCase } from "../../utils/String";

const KEY_REGEX = /^(F[1-12])|([A-Za-z0-9])|Enter$/;
export class ShortCutKeyDescritpion {
    constructor(...args) {
        console.log("#-# init ShortCutKeyDescritpion");
        const keyArray = (args || []).map((arg) => ("" + arg).toLocaleLowerCase());
        this.ctrl = keyArray.includes("ctrl");
        this.alt = keyArray.includes("alt");
        this.shift = keyArray.includes("shift");
        this.moment = "keyup";
        this.key = "";

        keyArray
            .filter((k) => KEY_REGEX.test(k))
            .forEach((k) => {
                this.key = firstLetterUpperCase(k);
            });
    }

    get triggerMoment() {
        return this.moment;
    }

    set triggerMoment(value) {
        this.moment = value;
    }

    get label() {
        let res = [];
        this.ctrl && res.push("Ctrl");
        this.alt && res.push("Alt");
        this.shift && res.push("Shift");
        this.key && res.push(this.key);
        return res.join("+");
    }

    /**
     *
     * @param {String} text
     */
    static parse(text) {
        let segments = (text || "").split("+");
        segments.forEach((s) => s.trim());
        segments = segments.filter((s) => s.length > 0);
        return new ShortCutKeyDescritpion(...segments);
    }
}

/**
 *
 * @param {KeyboardEvent} event
 */
function getKeyBoardEventLabel(event) {
    const res = [];
    if (event.ctrlKey) res.push("Ctrl");
    if (event.altKey) res.push("Alt");
    if (event.shiftKey) res.push("Shift");
    res.push(firstLetterUpperCase(event.key));
    return res.join("+");
}

export class KeySubscriber {
    constructor() {
        this.keydownSubscribers = new Map();
        this.keyupSubscribers = new Map();
        this._keydownHandler = this._keyupHandler = null;
    }

    /**
     *
     * @param {ShortCutKeyDescritpion} description
     * @param {Function} cb
     * @returns
     */
    subscribe(description, cb) {
        console.log("#-# subscribe");
        if (!description || !cb) return;
        if (description instanceof Array) {
            description = new ShortCutKeyDescritpion(description);
        }
        const trigger = description.triggerMoment;
        if (trigger === "keydown") {
            this.keydownSubscribers.set(description.label, cb);
        } else if (trigger === "keyup") {
            this.keyupSubscribers.set(description.label, cb);
        }
    }

    start() {
        this._keydownHandler = (ev) => {
            console.log("#-# _keydownHandler", this.keydownSubscribers);
            const eventKey = getKeyBoardEventLabel(ev);
            if (this.keydownSubscribers.has(eventKey)) {
                ev.preventDefault();
                this.keydownSubscribers.get(eventKey)(ev);
            }
        };
        this._keyupHandler = (ev) => {
            console.log("#-# _keyupHandler", this.keyupSubscribers);
            const eventKey = getKeyBoardEventLabel(ev);
            if (this.keyupSubscribers.has(eventKey)) {
                ev.preventDefault();
                this.keyupSubscribers.get(eventKey)(ev);
            }
        };

        window.addEventListener("keydown", this._keydownHandler, true);
        window.addEventListener("keyup", this._keyupHandler, true);
    }

    shutdown() {
        if (!!this._keydownHandler) {
            window.removeEventListener("keydown", this._keydownHandler);
            window.removeEventListener("keyup", this._keyupHandler);
        }
    }
}

export {
    RibbonBlock,
    RibbonBlockGroup,
    RibbonPanel,
    RibbonTable,
    RibbonButton,
    RibbonCheck,
    RibbonDropMenu,
    RibbonDropMenuItem,
};
